define('presentation/login/viewModels/accountCreationInProgressViewModel',[
    'businessServices/authentication/authenticationManager',
    'businessServices/authentication/sessionWorkflowFlags',
    'common/promises/promiseFactory',
    'constants/colorConstants',
    'presentation/common/modal',
    'plugins/router'
], function () {
    return function () {
        let self = this;

        const PromiseFactoryConstructor = require('common/promises/promiseFactory');
        let _promiseFactory = new PromiseFactoryConstructor();

        const _colorConstants = require('constants/colorConstants');

        self.spinnerColor = _colorConstants.colorSecondaryWarm400;

        self.activate = () => _initialize();

        const _initialize = () => {
            return _promiseFactory.wait();
        };
    };
});
